import api, { API_CONFIG } from "./api";

const CACHE_TTL = 10 * 60 * 1000; // 10 minutes

function getCached(key) {
  try {
    const item = sessionStorage.getItem(key);
    if (!item) return null;
    const { data, timestamp } = JSON.parse(item);
    if (Date.now() - timestamp > CACHE_TTL) {
      sessionStorage.removeItem(key);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

function setCache(key, data) {
  try {
    sessionStorage.setItem(key, JSON.stringify({ data, timestamp: Date.now() }));
  } catch { /* ignore quota errors */ }
}

// Fetch games by vendor/provider
export async function getGamesByVendor(vendor, page = 1, perPage = 24) {
  const cacheKey = `games_${vendor}_${page}`;
  const cached = getCached(cacheKey);
  if (cached) return cached;

  try {
    const res = await api.get(`/jsGames/games?vendor=${vendor}&page=${page}&per_page=${perPage}`);
    const result = {
      games: res?.payload?.games || res?.data || [],
      pagination: res?.payload?.pagination || { current_page: page, total_pages: 1 },
    };
    setCache(cacheKey, result);
    return result;
  } catch (err) {
    console.warn(`[gameService] Failed to fetch ${vendor}:`, err.message);
    return { games: [], pagination: { current_page: page, total_pages: 1 } };
  }
}

// Fetch hot games
export async function getHotGames(page = 1, limit = 40) {
  try {
    const res = await api.get(`${API_CONFIG.BASE_URL}/api/gis/games/hotgames?page=${page}&limit=${limit}`);
    return { games: res?.data || [], total: res?.total || 0 };
  } catch (err) {
    console.warn("[gameService] Failed to fetch hot games:", err.message);
    return { games: [], total: 0 };
  }
}

// Fetch games for multiple vendors in batches
export async function getGamesByVendors(vendors, batchSize = 6) {
  const results = {};

  for (let i = 0; i < vendors.length; i += batchSize) {
    const batch = vendors.slice(i, i + batchSize);
    const batchResults = await Promise.all(
      batch.map((vendor) => getGamesByVendor(vendor))
    );
    batch.forEach((vendor, idx) => {
      results[vendor] = batchResults[idx];
    });
  }

  return results;
}

// Launch a game
export async function launchGame(gameUid, userId, currency = "INR") {
  try {
    const res = await api.post("/jsGamesv2/launch", {
      game_uid: gameUid,
      user_id: userId,
      credit_amount: 0,
      currency_code: currency,
      language: "en",
    });
    return res?.data?.game_launch_url || null;
  } catch (err) {
    console.error("[gameService] Failed to launch game:", err.message);
    return null;
  }
}

// Provider list used on home page
export const HOME_VENDORS = [
  "evolution", "pragmatic", "spribe", "microgaming", "pgsoft",
  "jili", "netent", "bgaming", "pragmaticlive",
];

export const ALL_VENDORS = [
  "evolution", "pragmatic", "spribe", "ezugi", "ideal", "microgaming",
  "pgsoft", "hacksaw", "jili", "netent", "pragmaticlive", "bgaming",
  "eazygaming", "skywind", "BigTimeGaming", "Playson", "Ag", "Playtech",
  "BNG", "PgsGaming", "Rich88", "NextSpin", "esports", "JDBGaming",
  "CQ9", "km", "Evoplay",
];
